// extracted by mini-css-extract-plugin
module.exports = {"badge":"UrgencySignalBadge_badge__AKTIY"};